import { useState } from "react";
import { numberFormat } from "../../../../utils/display";
import { COUNTRY_CERTIFICATE_MAPPERS } from "../../../../utils/PPA/PPAMasterList";
import Report from "../../Reports/Report";
import "./ContractOverview.css";

export default function ContractOverview({ contract, contractId }) {
  const [avgSpotPrice, setAvgSpotPrice] = useState(0);
  const [volumeReceived, setVolumeReceived] = useState(0);

  return (
    <div className="tabs__container__box">
      <div className="actions_box">
        <div className="contract_id_banner">
          <span className="banner_title">Contract ID</span>
          <span className="banner_id"> {contract.id} </span>
        </div>
        <div className="contract__param__details contract__param__details_overview">
          <div className="contract__param__cards">
            <div className="contract__param__card">
              <p className="param__name_overview">Spot Price</p>
              <p className="param__value_overview">
                {avgSpotPrice
                  ? `${numberFormat(avgSpotPrice, 2, 0)} ${contract.currency}`
                  : "NA"}
                <span className="greenTriangle"></span>
              </p>
            </div>
            <div className="contract__param__card">
              <p className="param__name_overview">Strike Price</p>
              <p className="param__value_overview">
                {" "}
                {contract.strikePrice} {contract.currency}
              </p>
            </div>
            <div className="contract__param__card">
              <p className="param__name_overview">Volume Of Energy Recieved</p>
              <p className="param__value_overview">
                {volumeReceived
                  ? `${numberFormat(volumeReceived, 3)} MWh`
                  : "NA"}
              </p>
            </div>
            <div className="contract__param__card">
              <p className="param__name_overview">{`${contract?.location ? COUNTRY_CERTIFICATE_MAPPERS[contract.location.toLowerCase()] : "LGC's/REC's"}  Received`}</p>
              <p className="param__value_overview">
                {volumeReceived ? `${numberFormat(volumeReceived, 0)} ` : "NA"}
                {/**
                 * TODO: uncomment once the logic has been implemented for green and red
                 */}
                {/* <span className="redTriangle"></span> */}
              </p>
            </div>
          </div>
        </div>
        {/* <div className="contract_graph_title">
                Forecasted Volume vs Actual Volume
            </div> */}
        {/* <iframe title="PowerChain Dashboard Mockup ExampleBar Page" className="offtaker-powerBI_report" src="https://app.powerbi.com/reportEmbed?reportId=07e709e2-0901-40ac-8f21-1633e9a4098d&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c" frameborder="0" allowFullScreen="true"></iframe> */}

        {/* <div className="contract_tile_legend">
                
                    <span className="legend_item">
                        <span className="rectangle light-blue"></span>
                        <span>Forecasted volume</span>
                    </span>
                    
                    <span className="legend_item">
                        <span className="rectangle dark-blue"></span>
                        <span>Actual volume</span>
                    </span>
                    
                </div> */}
        <Report
          contractId={contractId}
          view="summary"
          setAvgSpotPrice={setAvgSpotPrice}
          setVolumeReceived={setVolumeReceived}
        />
      </div>
      {/* <div className="powerBi-report-container">
                <PowerBIReport showTab={false} type="Multi_Tenancy_Contract_View - Offtaker" contractTitle={contract.contractTitle}/>
            </div> */}
    </div>
  );
}
